export function getFieldError({ field, touched, validation, errors }) {
  if (touched[field] && validation[field]) {
    return validation[field];
  }
  if (errors[field]) {
    return errors[field];
  }
  return null;
}